import React, { useEffect, useState } from "react";
import {
  Collapse,
  Descriptions,
  Divider,
  Spin,
  Table,
  Tag,
  Typography,
} from "antd";
import { get } from "../../../api/axios";
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router";
import { ArrowLeftOutlined } from "@ant-design/icons";
import { Link } from "react-router-dom";
import { checkPermission } from "../../control-sections/auth/ProtectedRoutes";

const { Title } = Typography;
const { Panel } = Collapse;

const ShowBuyers = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [fromLoading, setFromLoading] = useState(false);
  const [loading, setLoading] = useState(false);
  const [buyerProfile, setBuyerProfile] = useState([]);
  const [leads, setLeads] = useState([]);

  const columnsForLeads = [
    {
      title: " Id",
      dataIndex: "id",
    },
    {
      title: "Listing Title",
      render: ({ listing }) =>
        checkPermission("update-seller-listings") ? (
          listing ? (
            <Link to={`/listings/edit/${listing.id}`}>{listing.title}</Link>
          ) : (
            ""
          )
        ) : listing.title ? (
          listing.title
        ) : (
          ""
        ),
    },
    ,
    {
      title: "Seller Name",
      render: ({ seller }) =>
        checkPermission("update-seller") ? (
          seller ? (
            <Link to={`/sellers/edit/${seller.id}`}>{seller.name}</Link>
          ) : (
            ""
          )
        ) : seller.name ? (
          seller.name
        ) : (
          ""
        ),
    },
    {
      title: "Buyer Name",
      render: ({ buyer }) =>
        checkPermission("update-buyer") ? (
          buyer ? (
            <Link to={`/buyers/edit/${buyer.id}`}>{buyer.name}</Link>
          ) : (
            ""
          )
        ) : buyer.name ? (
          buyer.name
        ) : (
          ""
        ),
    },
    {
      title: "Action",
      dataIndex: "action",
    },
    {
      title: "Extra Data",
      dataIndex: "extra_data",
    },
    {
      title: "Created At",
      dataIndex: "created_at",
    },
  ];

  useEffect(() => {
    get(`buyers/${id}`).then((res) => {
      const { leads, ...rest } = res.data;
      setLeads(leads);
      const otherDataArray = Object.entries(rest).map(([key, value]) => ({
        key,
        value,
      }));
      setBuyerProfile([...otherDataArray]);
      setFromLoading(true);
    });
  }, []);

  return (
    <div>
      <Title level={2} className="text-main mb-2">
        <ArrowLeftOutlined onClick={() => navigate("/buyers")} />
        Buyer Details Page
      </Title>

      {fromLoading ? (
        <div className="row">
          <Collapse defaultActiveKey={["1"]}>
            <Panel header="Buyer Profile" key="1">
              {buyerProfile.length > 0 && (
                <div className="row">
                  <Descriptions bordered colon className="p-2">
                    {buyerProfile.map(
                      (item) =>
                        (item.key !== "country_code" &&
                          item.key !== "phone_number") && (
                          <Descriptions.Item label={item.key} key={item.key}>
                            {item.key == "is_active" ? (
                              <Tag
                                color={`${
                                  item.value == 1 ? "success" : "error"
                                }`}
                              >
                                {item.value == 1 ? "Active" : "Inactive"}
                              </Tag>
                            ) : item.key == "is_approved" ? (
                              <Tag
                                color={`${
                                  item.value == 1 ? "success" : "error"
                                }`}
                              >
                                {item.value == 1 ? "Approved" : "Rejected"}
                              </Tag>
                            ) : (
                              item.value
                            )}
                          </Descriptions.Item>
                        )
                    )}
                  </Descriptions>
                </div>
              )}
            </Panel>
            <Divider />
            <Panel header="Leads" key="2">
              <div className="row">
                <div className="w-100">
                  <Table
                    locale={{ emptyText: "There are no data" }}
                    loading={loading}
                    columns={columnsForLeads}
                    dataSource={leads}
                    size="small"
                    responsive
                    pagination={false}
                  />
                </div>
              </div>
            </Panel>
          </Collapse>
        </div>
      ) : (
        <div className="text-center">
          <Spin size="large" />
        </div>
      )}
    </div>
  );
};

export default ShowBuyers;
